export default __webpack_public_path__ + "static/blob3-7ad3573b3ce88a47abd48ddc9df0b202.svg";